<app-modal>
  <h5 modal-title>
    @if (addAddressForm.Id.value > 0) {
      @if (addAddressForm.model.Name == null || addAddressForm.model.Name == "") {
        '{{ formatAddressLabel() }}'
      } @else {
        '{{ addAddressForm.model.Name }}'
      }
      bewerken
    } @else {
      {{ labelName }}
      toevoegen
    }
  </h5>
  <div *ngIf="!isLoading" modal-body>
    <app-address-base-edit
      [alignRight]="false"
      [form]="addAddressForm"
      [showSelect]="false"
      [fields]="fields"
      [name]="labelName"
      (onUpdated)="onUpdated($event)"
      (onAdded)="onAdded($event)"
      (onCancel)="close()"
      [showNameOnEdit]="showNameOnEdit"
    ></app-address-base-edit>
  </div>
</app-modal>
